/**
 * Utility for Google Analytics 4 (GA4) and Meta Pixel Tracking
 */

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
    fbq: (...args: any[]) => void;
  }
}

// Interfaz estándar para productos en e-commerce (GA4)
export interface EcommerceItem {
  item_id: string;
  item_name: string;
  affiliation?: string;
  coupon?: string;
  currency?: string;
  discount?: number;
  index?: number;
  item_brand?: string;
  item_category?: string;
  item_category2?: string;
  item_category3?: string;
  item_category4?: string;
  item_category5?: string;
  item_list_id?: string;
  item_list_name?: string;
  item_variant?: string;
  location_id?: string;
  price?: number;
  quantity?: number;
}

export const trackEvent = (eventName: string, params?: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, params);
  }
};

export const trackPixelEvent = (eventName: string, params?: Record<string, any>, isCustom: boolean = false) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq(isCustom ? 'trackCustom' : 'track', eventName, params);
  }
};

export const trackPageView = (url: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'G-HDK80W7242', {
      page_path: url,
    });
  }
};

export const AnalyticsEvents = {
  // GA4 Standard E-commerce Events
  ADD_TO_CART: 'add_to_cart',
  REMOVE_FROM_CART: 'remove_from_cart',
  VIEW_ITEM: 'view_item',
  VIEW_ITEM_LIST: 'view_item_list',
  BEGIN_CHECKOUT: 'begin_checkout',
  ADD_SHIPPING_INFO: 'add_shipping_info',
  ADD_PAYMENT_INFO: 'add_payment_info',
  PURCHASE: 'purchase',
  
  // Custom Events
  CHECKOUT_PROGRESS: 'checkout_progress',
  PAYMENT_FAILED: 'payment_failed',
  ORDER_CANCELLED: 'order_cancelled',
  APPLY_COUPON: 'apply_coupon',
  OUT_OF_COVERAGE: 'out_of_coverage_inquiry',
  ORDER_PRINTED: 'order_printed',
  EXPORT_EXCEL: 'export_excel',
  IMPORT_EXCEL: 'import_excel',
};

// Helper methods to format our internal `Product` / `CartItem` to GA4 `EcommerceItem`
export const formatProductToGa4Item = (product: any, quantity: number = 1, listName: string = "catalogo"): EcommerceItem => {
  return {
    item_id: product.id,
    item_name: product.name,
    item_category: product.category,
    price: product.price,
    quantity: quantity,
    item_list_name: listName
  };
};

export const formatCartItemToGa4Item = (cartItem: any, index?: number): EcommerceItem => {
  return {
    item_id: cartItem.id,
    item_name: cartItem.name,
    item_category: cartItem.category,
    price: cartItem.unitPrice, // Unit price including variants/options
    quantity: cartItem.quantity,
    index: index
  };
};
